import { format, parse } from 'date-fns';
import { Eye } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import BackButton from '../../../components/BackButton';

const AudienceList = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const campaignId = params.get('campaignId');
    const templateId = params.get('templateId');

    const [userList, setUsersList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    const BUId = sessionStorage.getItem('BUId');



    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/Report/CampaignWiseContactsReport?BUId=${BUId}&CampaignId=${campaignId}&TemplateId=${templateId}`);

                if (!userResponse.ok) {
                    throw new Error('Failed to fetch data');
                }

                const data = await userResponse.json();
                setUsersList(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchUserData();
    }, [BUId]);


    const filteredUserList = userList.filter(user =>
        user.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.emailId.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredUserList.slice(indexOfFirstItem, indexOfLastItem);
console.log("filter",filteredUserList)
console.log("current",currentItems)
    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const totalPages = Math.ceil(filteredUserList.length / itemsPerPage);

    const handleViewClick = (mailLogId) => {
        navigate(`/AudienceDetailedList?mailLogId=${mailLogId}`);
    };
    const handleCustomRedirect = () => {
        navigate('/AllDetailsList');
      };
    return (

        <div className="min-h-screen bg-gray-50 p-6">

            <div className="container mx-auto bg-white shadow-lg rounded-lg overflow-hidden">

                {/* Header */}
                {/* <div className="bg-gray-200 p-4">
                    <h1 className="text-xl">Report</h1>
                </div> */}

                {/* Search Input */}
                <div className="p-4 bg-gray-100 border-b">
                <BackButton label="Back" onClickRedirect={handleCustomRedirect} />
                    <div className="max-w-md ml-auto relative">                 
                        <input
                            type="text"
                            placeholder="Search names,emails,date..."
                            className="w-full p-3 pl-10 text-gray-700 bg-white rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1);
                            }}
                        />
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 absolute left-3 top-3 text-gray-400"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                        </svg>
                    </div>
                </div>

                <>
                    {/* Table */}
                    <div className="w-full overflow-x-auto bg-white rounded-lg shadow">
                        <table className="w-full">
                            <thead className="bg-gradient-to-r from-blue-500 to-purple-600">
                                <tr>
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-white">Participiant Name</th>
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-white">Email Address</th>
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-white">Email Open Count</th>
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-white">Button Click Count</th>
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-white">Status</th>
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-white">Scheduled Date</th>
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-white">View</th>
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-gray-600 hidden">MailLogId</th> {/* Hidden column */}
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-gray-600 hidden">Campaign Id</th> {/* Hidden column */}
                                    <th className="px-6 py-3 text-left text-sm font-semibold text-gray-600 hidden">Template Id</th> {/* Hidden column */}
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {filteredUserList.length > 0 ? (
                                    currentItems.map((user, index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 text-sm text-gray-900">{user.firstName || ''}</td>
                                            <td className="px-6 py-4 text-sm text-gray-900">{user.emailId}</td>
                                            <td className="px-6 py-4 text-sm text-gray-900">{user.totalMailOpenCount}</td>
                                            <td className="px-6 py-4 text-sm text-gray-900">{user.totalButtonClickCount}</td>
                                            <td className="px-6 py-4 text-sm text-gray-900">{user.mailStatus}</td>
                                            <td className="px-6 py-4 text-sm text-gray-900"> {user.scheduledDate
                                                ? format(parse(user.scheduledDate, 'dd-MM-yyyy HH:mm:ss', new Date()), 'dd/MM/yyyy hh:mm a')
                                                : ''}</td>

                                            <td className="px-6 py-4">
                                       {user.mailLogId && (
                                       <button 
                                                    onClick={() => handleViewClick(user.mailLogId)}
                                                    className="flex items-center text-blue-600 hover:text-blue-800"
                                                >
                                                    <Eye className="h-5 w-5" />
                                                </button>)}

                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-900 hidden">{user.mailLogId}</td> {/* Hidden column data */}
                                            <td className="px-6 py-4 text-sm text-gray-900 hidden">{user.campaignId}</td> {/* Hidden column data */}
                                            <td className="px-6 py-4 text-sm text-gray-900 hidden">{user.templateId}</td> {/* Hidden column data */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="px-6 py-4 text-sm text-center text-gray-600">No Details found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="bg-gray-100 px-4 py-3 flex items-center justify-center space-x-2">
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Previous
                        </button>

                        {[...Array(totalPages)].map((_, index) => (
                            <button
                                key={index}
                                onClick={() => paginate(index + 1)}
                                className={`px-4 py-2 text-sm font-medium rounded-lg border 
                ${currentPage === index + 1
                                        ? 'bg-blue-500 text-white border-blue-500'
                                        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                                    }`}
                            >
                                {index + 1}
                            </button>
                        ))}

                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AudienceList;
